import StorageService from '../services/storage.service'
import {logout} from "./auth";

// Shared refresh promise — all concurrent 401s wait on the same token rotation
let _refreshPromise = null

const doRefresh = (fingerprint) => {
    if (_refreshPromise) return _refreshPromise
    const body_auth = JSON.stringify({ fingerprint })
    const headers_auth = { 'Content-Type': 'application/json' }
    _refreshPromise = fetch('/api/account/refresh', { method: 'POST', body: body_auth, headers: headers_auth })
        .then(res => res.status)
        .finally(() => { _refreshPromise = null })
    return _refreshPromise
}

const request = async (url, method = 'GET', body = null, headers = {}) => {
    try {
        if (body) {

            if (headers !== 'multipart'){
                headers['Content-Type'] = 'application/json'
                body = JSON.stringify(body)
            }
            else {
                headers = []
            }

        }

        var response = await fetch(url, {method,body,headers})

        const auth = StorageService.getLocalAuth()

        //если не авторизован, попробуем сделать refresh
        if (response.status === 401 && auth?.fingerprint) {
            console.log('update access key...')

            const refreshStatus = await doRefresh(auth.fingerprint)

            if (refreshStatus === 401) {
                await logout()
                window.location.href = '/';
                throw new Error('Сессия истекла. Пожалуйста, войдите снова.')
            }

            // еще раз выполнить запрос
            response = await fetch(url, {method,body,headers})
        }

        const contentType = response.headers.get("content-type")
        let data

        if (response.status === 503 && contentType?.includes("application/json")) {
            data = await response.json()
            if (data?.error?.code === 'MAINTENANCE') {
                await logout()
                window.location.href = '/'
                return
            }
        }

        if (data === undefined) {
            if (contentType?.includes("application/json")) {
                data = await response.json()
            } else {
                data = await response.text()
            }
        }

        console.log('('+ url +') Server:',data)
        if (!response.ok) {
            if (data && data.status && data.status === 'reset') {
                //если пользователю сбросили пароль принудительно
            } else if (url.includes('login')) {
                return {isOk: false, message: data.message}
            } else {
                const errorMessage = typeof data?.error === 'string'
                    ? data.error
                    : (data?.error?.message || data.message || 'Что-то пошло не так')
                const error = new Error(errorMessage)
                if (data?.code) error.code = data.code
                throw error
            }
        }
        return data
    } catch (e) {
        if (url.includes('login')) return {isOk: false, message: 'Неизвестная ошибка! Возможно, сервер недоступен.'}
        throw e
    }
}

export default request

/*export const err500res = {
    isOk: false,
    message: 'Не удалось загрузить данные с сервера! Попробуйте перезагрузить страницу..'
}*/
